<template>
  <v-container>
    <v-tabs v-model="tab">
      <v-tab key="project">Project</v-tab>
      <v-tab key="author">Author </v-tab>
      <v-tab key="graphics">Graphics</v-tab>
      <v-tab key="miscellaneous">Miscellaneous</v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item key="project">
        <project />
      </v-tab-item>
      <v-tab-item key="author">
        <author />
      </v-tab-item>
      <v-tab-item key="graphics">
        <graphics />
      </v-tab-item>
      <v-tab-item key="miscellaneous">
        <miscellaneous />
      </v-tab-item>
    </v-tabs-items>
  </v-container>
</template>

<script>
import Project from "./Project";
import Author from "./Author";
import Graphics from "./Graphics";
import Miscellaneous from "./Miscellaneous";

export default {
  name: "ProjectProperties",
  components: { Project, Author, Graphics, Miscellaneous },
  data() {
    return {
      tab: 0,
    };
  },
};
</script>
